import { pxToRem } from './px-to-rem';
export const generateBoxShadow = (boxShadowThemeObject) => `${pxToRem(boxShadowThemeObject.x)} ${pxToRem(boxShadowThemeObject.y)}
 ${pxToRem(boxShadowThemeObject.blur)} ${pxToRem(boxShadowThemeObject.spread)}
 ${boxShadowThemeObject.color}`;
//# sourceMappingURL=generate-box-shadow.js.map